import React from "react";

import { Grid } from "@mui/material";
import { Skeleton } from "@mui/material";

const SkeletonLanguages = () => {
  const heightText = 20;
  const heightAvatar = 24;
  const widthAvatar = 24;

  return (
    <Grid container direction="row" style={{ padding: "16px" }}>
      <Grid item xs={2} direction="column">
        <Skeleton variant="circular" height={heightAvatar} width={widthAvatar} />
      </Grid>
      <Grid item xs={10} direction="column">
        <Skeleton variant="text" height={heightText} width="100%" />
      </Grid>
    </Grid>
  );
};

export default SkeletonLanguages;
